export default __webpack_public_path__ + "static/media/vaxwerks_card_qr.4245061c.png";